let thisMenuData = {
    state: {
        profileData: {
            uid: 'uid-001',
            name: 'John',
            surname: 'Doe',
            photo_url: '/images/product-10.jpg'
        }
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
}

export default thisMenuData